<template lang="pug">
article.post-card.--article(
  :id="`post-${post.id}`"
  :class="classes"
  @click="gotoPost"
) 
  .post-card__wrapper
    .post-card__image(
      v-if="hasImage"
      :style="`background-image: url(${post.img})`"
    )

    .post-card__content
      post-title.post-card__title(
        :post="post"
        link
        @focus="isFocus = true"
        @blur="isFocus = false"
      )
      strong.post-card__subtitle(
        v-if="!!post.subtitle"
      ) {{ post.subtitle }}
      p {{ post.tagline }}

    post-card-footer(
      :post="post"
      :author="author"
    )
</template>

<script>
import PostResourceMixin from '@/mixins/postResource'
import PostTitle from '@/components/post/post-title'
import PostCardFooter from './post-card__footer'

export default {
  name: 'post-card--article',
  components: {
    PostTitle,
    PostCardFooter,
  },
  mixins: [PostResourceMixin],
  data() {
    return {
      isFocus: false,
    }
  },
  computed: {
    classes() {
      return {
        '--hasImage': this.hasImage,
        '--focus': this.isFocus,
      }
    },
  },
}
</script>

<style lang="sass">
.post-card.--article 
  background-color: white

  &:not(.--hasImage)      
    .post-card__wrapper
      border-top: var(--post-card-accent-border-width) solid var(--accent-color);
</style>